<h2 mat-dialog-title>Custom geometry</h2>

@let inputErrors = geometryForm.values().errors();

<mat-dialog-content>
  <form id="form" (submit)="submit($event)">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Shape</mat-label>
        <mat-select [formField]="geometryForm.type">
          <mat-option value="Point">Point</mat-option>
          <mat-option value="LineString">Line</mat-option>
          <mat-option value="Polygon">Polygon</mat-option>
        </mat-select>
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Coordinates</mat-label>
        <textarea
          rows="2"
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="15"
          matInput
          [formField]="geometryForm.values"
        >
        </textarea>
        @switch (geometryForm.type().value()) {
          @case ('Point') {
            <mat-hint>One point per line. Format: x y</mat-hint>
          }
          @case ('LineString') {
            <mat-hint>One line string (sequence of points) per line. Format: x1 y1, x2 y2</mat-hint>
          }
          @case ('Polygon') {
            <mat-hint
              >One polygon (sequence of points) per line, ending with the starting point. Format: x1
              y1, x2 y2, x1 y1</mat-hint
            >
          }
        }

        @if (inputErrors.length && inputErrors[0].message) {
          <mat-error>{{ inputErrors[0].message }}</mat-error>
        }
      </mat-form-field>
    </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-flat-button
    type="submit"
    form="form"
    [disabled]="geometryForm().invalid() || !geometryForm().dirty()"
  >
    Add
  </button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
